import { SE_HOUSEHOLD_INFO_NAV_TREE } from './se-household-info-docs/nav-tree'
import { SE_HOUSEHOLD_SETUP_NAV_TREE } from './se-household-setup-docs/nav-tree'
import { SE_INBOX_NAV_TREE } from './se-inbox-docs/nav-tree'
import { SE_MISSING_PERSONA_INFO_NAV_TREE } from './se-missing-persona-info-docs/nav-tree'
import { SE_MY_SPORTSENGINE_NAV_TREE } from './se-my-sportsengine-docs/nav-tree'
import { SE_PERSONA_PICKER_NAV_TREE } from './se-persona-picker-docs/nav-tree'
import { SE_REGISTRATION_UI_NAV_TREE } from './se-registration-ui-docs/nav-tree'
import { SHARED_NAV_TREE } from './shared-docs/nav-tree'

/**
 * this is used by the se-fe-left-nav component
 */
export const NAV_TREE = [
  { label: 'Home', key: 'home', attributes: { href: '/docs/index.hmtl' } },
  {
    label: 'Apps - Elements', secondaryItems: [
      { label: 'SeAccountMenu', key: 'se-account-menu-v1', attributes: { href: '/docs/apps/se-account-menu-v1' } },
      { label: 'SeAddGuardian', key: 'se-add-guardian', attributes: { href: '/docs/apps/se-add-guardian' } },
      { label: 'SeAddPerson', key: 'se-add-person', attributes: { href: '/docs/apps/se-add-person' } },
      {
        label: 'SeAdminPermissionsCard',
        key: 'se-admin-permissions-card',
        attributes: { href: '/docs/apps/se-admin-permissions-card' }
      },
      { label: 'SeAffiliationAccess', key: 'se-affiliation-access', attributes: { href: '/docs/apps/se-affiliation-access' } },
      { label: 'SeOrgSettings', key: 'se-org-settings', attributes: { href: '/docs/apps/se-org-settings' } },
      { label: 'SeAffiliationAdmins', key: 'se-affiliation-admins', attributes: { href: '/docs/apps/se-affiliation-admins' } },
      {
        label: 'SeAffiliationContactCard', key: 'se-affiliation-contact-card',
        attributes: { href: '/docs/apps/se-affiliation-contact-card' }
      },
      {
        label: 'SeDashboardNotifications',
        key: 'se-dashboard-notifications',
        attributes: { href: '/docs/apps/se-dashboard-notifications' }
      },
      { label: 'SeDirectory', key: 'se-directory', attributes: { href: '/docs/apps/se-directory' } },
      { label: 'SeDuplicateReview', key: 'se-duplicate-review', attributes: { href: '/docs/apps/se-duplicate-review' } },
      { label: 'SeHouseholdInfo', key: 'se-household-info', attributes: { href: '/docs/apps/se-household-info' } },
      { label: 'SeHqDashboard', key: 'se-hq-dashboard', attributes: { href: '/docs/apps/se-hq-dashboard' } },
      { label: 'SeLeftNav', key: 'se-left-nav', attributes: { href: '/docs/apps/se-left-nav' } },
      { label: 'SeMessageHistory', key: 'se-message-history', attributes: { href: '/docs/apps/se-message-history' } },
      { label: 'SeMessaging', key: 'se-messaging', attributes: { href: '/docs/apps/se-messaging' } },
      {
        label: 'SeMissingPersonaInfo',
        key: 'se-missing-persona-info',
        attributes: { href: '/docs/apps/se-missing-persona-info' }
      },
      { label: 'SeOrgAdminsList', key: 'se-org-admins-list', attributes: { href: '/docs/apps/se-org-admins-list' } },
      { label: 'SeOrgMessage', key: 'se-org-message', attributes: { href: '/docs/apps/se-org-message' } },
      { label: 'SePersonaPicker', key: 'se-persona-picker', attributes: { href: '/docs/apps/se-persona-picker' } },
      { label: 'SeProfile', key: 'se-profile', attributes: { href: '/docs/apps/se-profile' } },
      { label: 'SeProfileCard', key: 'se-profile-card', attributes: { href: '/docs/apps/se-profile-card' } },
      { label: 'SeSubscriptionCard', key: 'se-subscription-card', attributes: { href: '/docs/apps/se-subscription-card' } },
    ]
  },
  SE_HOUSEHOLD_SETUP_NAV_TREE,
  SE_HOUSEHOLD_INFO_NAV_TREE,
  SE_INBOX_NAV_TREE,
  SE_MISSING_PERSONA_INFO_NAV_TREE,
  SE_MY_SPORTSENGINE_NAV_TREE,
  SE_PERSONA_PICKER_NAV_TREE,
  SE_REGISTRATION_UI_NAV_TREE,
  SHARED_NAV_TREE
]
